import { render, staticRenderFns } from "./control_pad.vue?vue&type=template&id=08819b70&scoped=true&"
import script from "./control_pad.vue?vue&type=script&lang=js&"
export * from "./control_pad.vue?vue&type=script&lang=js&"
import style0 from "./control_pad.vue?vue&type=style&index=0&id=08819b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08819b70",
  null
  
)

export default component.exports